module.exports = __webpack_public_path__ + "static/media/hamburger.f6056f04.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/hamburger.svg
// module id = 473
// module chunks = 0